import ActivityMessaging from '../../molecules/activity-messaging/ActivityMessaging';
import Image from '../../atoms/image/Image.tsx';

export type ActivityMessagingShopImageFieldProps = {
  fileSrc?: string;
  redirectionUrl?: string;
};

export const ActivityMessagingShopImageField = ({
  fileSrc,
  redirectionUrl,
}: ActivityMessagingShopImageFieldProps) => {
  if (!fileSrc) {
    return null;
  }

  return (
    <ActivityMessaging.Root className="relative">
      <Image.Root src={fileSrc} className="h-60 rounded-xl">
        <Image.Img className="object-fill" />
        <Image.Loading />
        <Image.Error />
      </Image.Root>

      {redirectionUrl && (
        <a
          href={redirectionUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="absolute inset-0"
        />
      )}
    </ActivityMessaging.Root>
  );
};
